module.exports = __webpack_public_path__ + "img/shopping-bag.a2dca85b.webp";